"use client";

import Link from "next/link";
import { FaMailBulk, FaPhone } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Imprint() {
  return (
    <div className="min-h-screen w-full flex flex-col bg-[#141414] text-white">
      <Navbar />

      <div className="m-0 flex min-h-screen w-full items-center">
        <main className="w-full flex flex-col items-center justify-start py-8 pt-24">

          <section className="w-[92%] sm:w-4/5 md:w-3/5 lg:w-1/2 xl:w-[40%] mt-2 mb-12">
            <div className="rounded-2xl bg-[#1b1b1b]/80 backdrop-blur ring-1 ring-white/10 shadow-2xl p-6 sm:p-8">
              {/* 2. Enhanced H1 with Keywords */}
              <h1 className="text-center font-extrabold tracking-tight text-3xl sm:text-4xl text-emerald-400">
                Imprint & Legal Notice for CasinoB8
              </h1>

              {/* 3. SEO-Optimized Descriptive Content */}
              <p className="mt-4 text-sm text-gray-300">
                Welcome to CasinoB8. This page provides the mandatory
                **legal company information** (Imprint/Impressum) for the
                operation of our **online casino review and comparison
                service**. We are committed to transparency and compliance with
                all relevant international and European legal frameworks
                regarding digital services and **gambling market information**.
                Our primary goal is to provide accurate, up-to-date guidance for
                players seeking reliable information on the world's leading
                **online casino** platforms.
              </p>
              <p className="mt-3 text-sm text-gray-300">
                For customer support, partnership inquiries, or legal
                correspondence, please use the contact details provided below.
              </p>

              <hr className="mt-6 border-white/10" />

              <h2 className="mt-6 font-extrabold text-xl text-emerald-400">
                Official Company Details
              </h2>
              <address className="not-italic mt-3 space-y-1 text-gray-200">
                <p className="font-semibold text-lg">
                  Hype Grow, Unipessoal Lda
                </p>
                <p>Rua Dr. António Loureiro Borges, n.º 1, 2nd Floor</p>
                <p>1495-131 Algés</p>
                <p>Portugal</p>
              </address>

              <h2 className="mt-6 font-extrabold text-xl text-emerald-400">
                Contact Information
              </h2>
              <div className="mt-3 space-y-3 text-gray-200">
                <p className="flex items-center">
                  <FaPhone className="mr-3 text-emerald-400 min-w-4" />
                  <a
                    href="tel:+491744149494"
                    className="hover:text-emerald-300 underline-offset-4 hover:underline"
                  >
                    +49 174 4149494 (General Inquiries)
                  </a>
                </p>
                <p className="flex items-center">
                  <FaMailBulk className="mr-3 text-sky-400 min-w-4" />
                  <a
                    href="mailto:info@casinob8.com"
                    className="hover:text-sky-300 underline-offset-4 hover:underline"
                  >
                    info@casinob8.com (Legal & Customer Support)
                  </a>
                </p>
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </div>
  );
}
